export default "//static.tradera.net/touchweb/static/output/images/visa.eab606d5.svg";